// extracted by mini-css-extract-plugin
export default {"label":"Toggle_label__nMiMo","input":"Toggle_input__VxUjg","span":"Toggle_span__5wF1F","strong":"Toggle_strong__KPozW"};